import { getPools } from "../../../../api/pools"

export const MASTER_FIELDS = [

]


export const MEDIA_FIELDS = [

    { key: 'name', label: "Name" },
    { key: 'date_from', label: "From Date", type: "date",  },
    { key: 'date_to', label: "To Date", type: "date"},

]




const FIELDS = [
    ...MEDIA_FIELDS,
    ...MASTER_FIELDS
]

export default FIELDS


